var Marionette = require('backbone.marionette');

var Constants = require('../../utils/constants');
var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var DocumentsStatisticsAggregateView = Marionette.View.extend({
    template: require('../../templates/statistics/documents-statistics-aggregate-view.html'),

    modelEvents: {
        change: 'render'
    },

    ui: {
        sendingMethod: '#sending-method',
        contactValueInput: '#contact-value',
        letterRangeFilterField: '.letter-range-filter-field',

        aggregates: "#aggregates",
        applyAggregates: '#apply-aggregates',

        selectDoc: '.doc-select',
        docGroupSelect: '.doc-group-select',
        actionBtn: '.action-btn'
    },

    events: {
        'click #sending-method a': 'selectSendingMethod',
        'click .contact-type': 'onContactTypeChanged',
        'change @ui.contactValueInput': 'onContactValueChanged',
        'change @ui.letterRangeFilterField': 'onChangeLetterRangeFilterField',
        'click @ui.applyAggregates': 'onApplyAggregates',
        "click @ui.selectDoc": 'onDocumentSelected',
        "click @ui.docGroupSelect": 'onChildDocumentsSelected',

        'click #agg-stat-download': 'onDownload',
        'click #agg-stat-print': 'onPrint',
        'click #agg-sign-all': 'onSign',
        'click #agg-addendum': 'onAddAddendum',
        'click #agg-stat-assign': 'onAssign',
        'click #agg-stat-add-patient': 'onAddPatient',
        'click #agg-stat-set-due': 'onSetDue',
        'click #agg-stat-audit': 'onAudit',
        'click #agg-stat-send': 'onSend',
        'click #agg-stat-mark-as-sent': 'onMarkAsSent',
        'click #agg-stat-mark-as-delivered': 'onMarkAsDelivered',
        'click #agg-stat-open-selected': 'onOpenSelectedDocuments',

        'click .expand-collapse-all': 'onExpandOrCollapse'
    },

    initialize: function (options) {

        var that = this;

        _.bindAll(this, 'onRender', 'onApplyAggregates', 'getAggregateTypes', 'getSelectedAggregates', 'getSelectedAggregatesNames',
            'getSelectedAggregatesCaptions', 'nodeNameOrAsLink', 'nodeId', 'nodeNameIsNoValue', 'documentsLink',
            'signedLink', 'pendingLink', 'viewedLink', 'unreviewedLink', 'deletedLink', 'underReviewLink', 'totalLink',
            'getChildrenValues', 'onDocumentSelected');

        that.utils = new CommonUtils();

        that.contactTypes = that.utils.getContactTypes();

        that.data = options.data;
        that.aggregateParams = options.aggregateParams;
        console.log(that.aggregateParams);
        that.extraParams = options.extraParams;
        console.log(that.extraParams);

        that.extraParamsAsString = that.extraParamsToString();
        that.getSelectedDocuments = options.getSelectedDocuments;

        that.selectedSendingMethods = that.aggregateParams["contactTypes"] || [];
        that.sendingMethodsState = {}
        _.keys(that.contactTypes).forEach(function (method) {
            that.sendingMethodsState[method] = (_.contains(that.selectedSendingMethods, method) ? 'active' : 'notActive');
        });

        this.model = new Backbone.Model({
            tree: {
                children: that.data
            }
        });

        this.noValue = 'NO VALUE';
        this.filtersChanged = false;

        this.initTitleCaptions();
    },

    templateContext: function () {
        var that = this;

        return {
            transformSendingMethods: function (contactTypes) {
                var groupedBySendingMethods = _.groupBy(contactTypes, function (method) {
                    return method;
                });
                return _.keys(groupedBySendingMethods).map(function (method) {
                    return {
                        methodName: method,
                        count: (groupedBySendingMethods[method] || []).length > 1 ? groupedBySendingMethods[method].length : ''
                    }
                });
            },
            contactTypes: that.contactTypes,
            sendingMethodsState: that.sendingMethodsState,
            upperCaseChars: that.utils.getUpperCaseCharsList(),
            orgNameFrom: that.aggregateParams["orgNameFrom"],
            orgNameTo: that.aggregateParams["orgNameTo"],
            mdNameFrom: that.aggregateParams["mdNameFrom"],
            mdNameTo: that.aggregateParams["mdNameTo"],
            contactValue: that.aggregateParams["contactValue"],

            aggregatesList: that.getSelectedAggregates(),
            aggregatesNamesList: that.getSelectedAggregatesNames(),
            aggregatesCaptionsList: that.getSelectedAggregatesCaptions(),

            getChildrenValues: that.getChildrenValues,
            nodeNameOrAsLink: that.nodeNameOrAsLink,
            nodeId: that.nodeId,
            nodeNameIsNoValue: that.nodeNameIsNoValue,

            pendingLink: that.pendingLink,
            signedLink: that.signedLink,
            viewedLink: that.viewedLink,
            unreviewedLink: that.unreviewedLink,
            deletedLink: that.deletedLink,
            underReviewLink: that.underReviewLink,
            totalLink: that.totalLink,

            generateCollapseId: function (node, order, indexes) {
                var fieldName = that.getSelectedAggregates()[order];
                var id = node[fieldName];
                if (id == that.noValue)
                    return fieldName + _.allKeys(node.children).slice(1, 5).map(function (key) {
                        return key.replace(" ", "").replace(".", "").replace(/\//g, "");
                    }).join("-").replace(/\s/g, "").replace(/\./g, "").replace(/,/g, "").replace(/@/g, "") + order + "-" + indexes.join('-');
                else
                    return id.replace(/\s/g, "").replace(/\./g, "").replace(/,/g, "").replace(/@/g, "") + order + "-" + indexes.join('-');
            }
        }
    },

    onRender: function () {
        var that = this;

        that.ui.aggregates.selectize({
            plugins: ['remove_button'],
            inputClass: 'form-control selectize-input normal-width selectized',
            placeholder: 'Add Aggregates (max 3), implicitly always last aggregate is "Document Name"',
            valueField: 'value',
            labelField: 'name',
            options: that.getAggregateTypes().filter(function (type) {
                return type.value != "DOCUMENT";
            }),
            items: function () {
                if (typeof that.aggregateParams["aggregates"] != "undefined") {
                    return Array.isArray(that.aggregateParams["aggregates"])
                        ? that.aggregateParams["aggregates"]
                        : [that.aggregateParams["aggregates"]];
                } else {
                    return [];
                }
            }(),
            highlight: true,
            openOnFocus: true,
            maxItems: 3
        });

        that.initCollapseEvents();
    },

    initCollapseEvents: function () {
        console.log('initCollapseEvents');
        var that = this;
        $(function () {
            $('.expandable').on('shown.bs.collapse', function (e) {
                var self = $(this);
                if (self.is(e.target)) {
                    var collapseControl = $('#' + self.attr('id') + "_control");
                    collapseControl.html('<span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>');
                }
            });
            $('.expandable').on('hidden.bs.collapse', function (e) {
                var self = $(this);
                if (self.is(e.target)) {
                    var collapseControl = $('#' + self.attr('id') + "_control");
                    collapseControl.html('<span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>');
                }
            });
            /*that.ui.selectDoc.change(function () {
                console.log('change');
                that.handleDocumentsSelect(this.checked, this.name);
            });*/
            /*$('.document-checkbox').click(function () {
                console.log('click');
                console.log($(this));
                var self = $(this);
                if (self.hasClass('doc-select'))
                    that.handleDocumentsSelect(self.checked, [self.name]);
            });*/

            //that.expandAll($('.expand-collapse-all i'));

        });
    },

    initTitleCaptions: function () {
        var that = this;
        that.titleCaptions = _.extend(Dicts.documentIntention, Dicts.documentStatuses);
    },

    onApplyAggregates: function () {
        var that = this;
        var aggregates = that.ui.aggregates.val();
        var aggregatesAsArray = aggregates.split(',');
        aggregatesAsArray.push("DOCUMENT"); // Always DOCUMENT is last aggregate in report

        if (_.isEqual(aggregatesAsArray, that.aggregateParams["aggregates"]) && !that.filtersChanged
            || (_.isEmpty(aggregates) && _.isUndefined(that.aggregateParams["aggregates"])))
            return;

        if (_.isEmpty(aggregates)) {
            delete that.aggregateParams["aggregates"];
        } else {
            that.aggregateParams["aggregates"] = aggregatesAsArray;
        }

        var contactValueForFilter = that.ui.contactValueInput.val();
        if (_.isEmpty(contactValueForFilter))
            delete that.aggregateParams["contactValue"];
        else
            that.aggregateParams["contactValue"] = contactValueForFilter;

        if (_.isEmpty(that.selectedSendingMethods)) {
            delete that.aggregateParams["contactTypes"];
        } else {
            that.aggregateParams["contactTypes"] = that.selectedSendingMethods;
        }

        that.ui.letterRangeFilterField.each(function () {
            that.aggregateParams[$(this).attr("name")] = $(this).val();
        });

        that.triggerMethod('statistics:aggregate', that.aggregateParams);
        that.filtersChanged = false;
    },

    getAggregateTypes: function () {
        return [
            {name: 'Assigned Organization', value: 'ORGANIZATION_REVIEW_REQUEST'},
            {name: 'Signed By Organization', value: 'ORGANIZATION_REVIEW_FINISHED_REQUEST'},
            {name: 'Obsoleted By Organization', value: 'ORGANIZATION_REVIEW_DELETED'},
            {name: 'Assigned Person', value: 'PERSON_REVIEW_REQUEST'},
            {name: 'Signed By Person', value: 'PERSON_REVIEW_FINISHED_REQUEST'},
            {name: 'Obsoleted By Person', value: 'PERSON_REVIEW_DELETED'},
            {name: 'Patient', value: 'DOCUMENT_PATIENT'},
            {name: 'Requesting Organization', value: 'DOCUMENT_ORGANIZATION'},
            {name: 'Document Uploader Person', value: 'DOCUMENT_UPLOADER_PERSON'},
            {name: 'Created Date', value: 'CREATED_TIME'},
            {name: 'Due Date', value: 'DUE_DATE'},
            {name: 'Sign Date', value: 'SIGNED_TIME'},
            {name: 'Intention', value: 'INTENTION'},
            {name: 'Sign Status', value: 'STATUS'},
            {name: 'Delivery Status', value: 'DELIVERY_STATUS'},
            {name: 'Document Name', value: 'DOCUMENT'}
        ]
    },

    getSelectedAggregates: function () {
        return _.first(this.aggregateParams["aggregates"] || [], 4);
    },

    getSelectedAggregatesNames: function () {
        return this.getSelectedAggregates().map(function (agg) {
            return agg + "_NAME";
        })
    },

    getSelectedAggregatesCaptions: function () {
        var that = this;
        return that.getSelectedAggregates().map(function (agg) {
            return _.findWhere(that.getAggregateTypes(), {value: agg}).name;
        })
    },

    getChildrenValues: function (children, aggIndex) {
        var that = this;
        var nodeType = that.getSelectedAggregates()[aggIndex];

        if (nodeType == "CREATED_TIME" || nodeType == "DUE_DATE" || nodeType == "SIGNED_TIME") {
            return _.sortBy(_.values(children) || [], function (child) {
                var sortFieldForDate = child[nodeType];
                return new Number(sortFieldForDate);
            });
        } else {
            return _.sortBy(_.values(children) || [], function (child) {
                if (child[nodeType + "_NAME"] == that.noValue)
                    return "";
                return child[nodeType + "_NAME"];
            });
        }
    },

    nodeId: function (node, aggIndex) {
        return node[this.getSelectedAggregates()[aggIndex]];
    },

    nodeNameOrAsLink: function (node, aggIndex) {
        var id = node[this.getSelectedAggregates()[aggIndex]];
        var title = node[this.getSelectedAggregatesNames()[aggIndex]];
        var nodeType = this.getSelectedAggregates()[aggIndex];

        title = this.formatted(title);

        if (id == this.noValue)
            return '<a>' + title + '</a>';

        switch (nodeType) {
            case 'ORGANIZATION_REVIEW_REQUEST':
            case 'ORGANIZATION_REVIEW_FINISHED_REQUEST':
            case 'ORGANIZATION_REVIEW_DELETED':
            case 'DOCUMENT_ORGANIZATION':
                return '<a href="/#organization/' + id + '"  target="_blank">' + title + '</a>';
            case 'PERSON_REVIEW_REQUEST':
            case 'PERSON_REVIEW_FINISHED_REQUEST':
            case 'PERSON_REVIEW_DELETED':
            case 'DOCUMENT_PATIENT':
            case 'DOCUMENT_UPLOADER_PERSON':
                return '<a href="/#person/' + id + '"  target="_blank">' + title + '</a>';
            case 'DOCUMENT':
                return '<a href="/#document/' + id + '"  target="_blank">' + title + '</a>';

            default:
                return '<a>' + title + '</a>';
        }
    },

    formatted: function (title) {
        return (this.titleCaptions[title] || title).toUpperCase();
    },

    nodeNameIsNoValue: function (node, aggIndex) {
        var id = node[this.getSelectedAggregates()[aggIndex]];
        //return id == this.noValue;
        return false;
    },

    signedLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=SIGNED';
        }
        return link;
    },

    viewedLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=VIEWED';
        }
        return link;
    },

    pendingLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=IN_REVIEW';
        }
        return link;
    },

    unreviewedLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=UNREVIEWED';
        }
        return link;
    },

    deletedLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=DELETED';
        }
        return link;
    },

    underReviewLink: function (nodes) {
        var link = this.documentsLink(nodes);
        if (link.indexOf("object_status") < 0) {
            return link + '&object_status=UNDER_REVIEW';
        }
        return link;
    },

    totalLink: function (nodes) {
        var link = this.documentsLink(nodes);
        return link;
    },

    documentsLink: function (nodes) {
        var that = this;

        var link = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);

        var params = (nodes || []).map(function (node, index) {
            return that.nodeToParams(node, index, nodes.length == index + 1);
        });

        link = link + "&" + params.join("&");

        return link;
    },

    wasReportFiltersApplied: function () {
        return this.aggregateParams["contactValue"]
            || this.aggregateParams["contactTypes"]
            || this.aggregateParams["orgNameFrom"] && this.aggregateParams["orgNameFrom"] != "A"
            || this.aggregateParams["orgNameTo"] && this.aggregateParams["orgNameTo"] != "Z"
            || this.aggregateParams["mdNameFrom"] && this.aggregateParams["mdNameFrom"] != "A"
            || this.aggregateParams["mdNameTo"] && this.aggregateParams["mdNameTo"] != "Z";
    },

    nodeToParams: function (node, index, isLast) {
        var nodeType = this.getSelectedAggregates()[index];
        var id = node[this.getSelectedAggregates()[index]];

        if ((id == this.noValue || nodeType == 'STATUS')) {
            if (isLast)
                return node.documentIds.map(function (id) {
                    return 'id=' + id;
                }).join("&");
            else
                return ""; // in the future will be here relation not exists filter
        }

        if (this.wasReportFiltersApplied() && isLast) {
            return node.documentIds.map(function (id) {
                return 'id=' + id;
            }).join("&");
        } else
            console.log("Filters was empty");

        var twelveHour = 1000 * 60 * 60 * 12;

        switch (nodeType) {
            case 'ORGANIZATION_REVIEW_REQUEST':
                return 'ORGANIZATION_REVIEW_REQUEST=' + id;
            case 'ORGANIZATION_REVIEW_FINISHED_REQUEST':
                return 'ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id;
            case 'ORGANIZATION_REVIEW_DELETED':
                return 'ORGANIZATION_REVIEW_DELETED=' + id;
            case 'PERSON_REVIEW_REQUEST':
                return 'PERSON_REVIEW_REQUEST=' + id;
            case 'PERSON_REVIEW_FINISHED_REQUEST':
                return 'PERSON_REVIEW_FINISHED_REQUEST=' + id;
            case 'PERSON_REVIEW_DELETED':
                return 'PERSON_REVIEW_DELETED=' + id;
            case 'DOCUMENT_PATIENT':
                return 'DOCUMENT_PATIENT=' + id;
            case 'DOCUMENT_ORGANIZATION':
                return 'DOCUMENT_ORGANIZATION=' + id;
            case 'DOCUMENT_UPLOADER_PERSON':
                return 'DOCUMENT_UPLOADER_PERSON=' + id;
            case 'DOCUMENT':
                return 'id=' + id;
            case 'CREATED_TIME':
                //return 'object_createdTime_from=' + (new Number(id) - twelveHour) + '&' + 'object_createdTime_to=' + (new Number(id) + twelveHour);
                return 'object_createdTime_date=' + (new Number(id));
            case 'DUE_DATE':
                //return 'object_dueDate_from=' + (new Number(id) - twelveHour) + '&' + 'object_dueDate_to=' + (new Number(id) + twelveHour);
                return 'object_dueDate_date=' + (new Number(id));
            case 'SIGNED_TIME':
                //return 'object_signedTime_from=' + (new Number(id) - twelveHour) + '&' + 'object_signedTime_to=' + (new Number(id) + twelveHour);
                return 'object_signedTime_date=' + (new Number(id));
            case 'INTENTION':
                return 'object_intention=' + id;
            /*case 'STATUS':
                return 'object_status=' + id;*/
            case 'DELIVERY_STATUS':
                if (id == 'NOT SENT') {
                    return 'object_lastSentTime=0';
                } else if (id == 'NOT DELIVERED') {
                    return 'object_lastDeliveredTime=0&object_lastSentTime_from=1';
                } else if (id == 'DELIVERED') {
                    return 'object_lastDeliveredTime_from=1'
                }
            default:
                return "";
        }
    },

    onContactValueChanged: function (event) {
        this.filtersChanged = true;
    },

    onChangeLetterRangeFilterField: function (event) {
        this.filtersChanged = true;
    },

    selectSendingMethod: function (event) {
        var target = $(event.target);
        var value = target.data('title');
        var isActive = target.hasClass('active');

        if (!isActive) {
            target.removeClass('notActive').addClass('active');
            this.selectedSendingMethods.push(value);
        } else {
            target.removeClass('active').addClass('notActive');
            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
                return method == value;
            });
        }

        this.filtersChanged = true;
    },

    onContactTypeChanged: function (event) {
        var contactType = event.target.value;
        if (event.target.checked) {
            this.selectedSendingMethods.push(contactType);
        } else {
            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
                return method == contactType;
            });
        }
        this.filtersChanged = true;
    },

    onDocumentSelected: function (event) {
        this.handleDocumentsSelect(event.target.checked, [event.target.name]);
    },

    handleDocumentsSelect: function (checked, ids) {
        if (checked)
            this.triggerMethod('aggregate:documents:selected', ids);
        else
            this.triggerMethod('aggregate:documents:unselected', ids);
        this.onOffButtons();

        //$(function () {
        ids.forEach(function (id) {
            $(":checkbox[name='" + id + "']").each(function () {
                console.log('success-el');
                $(this).removeClass("success-el");
                $(this).removeClass("error-el");
            });
        })
        //});
    },

    onChildDocumentsSelected: function (event) {
        var that = this;
        var el = $(event.target);
        var state = event.target.checked;
        window.setTimeout(function () {
            el.closest('.level-group').find('.document-checkbox').each(function () {
                if ($(this) != el) {
                    $(this).prop('checked', state);
                    if ($(this).hasClass("doc-select"))
                        that.handleDocumentsSelect(state, [$(this).prop("name")]);
                }
            });
        }, 0);
    },

    onOffButtons: function () {
        var isSelectedDocExists = false;
        $('input:checkbox.doc-select').each(function () {
            isSelectedDocExists = isSelectedDocExists || this.checked;
        });

        if (isSelectedDocExists)
            this.ui.actionBtn.removeAttr("disabled");
        else
            this.ui.actionBtn.attr("disabled", true);
    },

    onDownload: function () {
        console.log("onDownload");
        this.triggerMethod('aggregate:download');
    },

    onPrint: function () {
        console.log("onPrint");
        this.triggerMethod('aggregate:print');
    },

    onSign: function () {
        console.log("onSign");
        this.triggerMethod('aggregate:sign', function (successDocIds, errorDocIds) {
            console.log(successDocIds);
            successDocIds.forEach(function (id) {
                $(":checkbox[name='" + id + "']").each(function () {
                    $(this).addClass("success-el");
                });
            });
            console.log(errorDocIds);
            errorDocIds.forEach(function (id) {
                $(":checkbox[name='" + id + "']").each(function () {
                    $(this).addClass("error-el");
                });
            })
        });
    },

    onAddAddendum: function () {
        console.log("onAddAddendum");
        this.triggerMethod('aggregate:add:addendum');
    },

    onAssign: function () {
        console.log("onAssign");
        this.triggerMethod('aggregate:assign');
    },

    onAddPatient: function () {
        console.log("onAddPatient");
        this.triggerMethod('aggregate:add:patient');
    },

    onSetDue: function () {
        console.log("onSetDue");
        this.triggerMethod('aggregate:set:due');
    },

    onAudit: function () {
        console.log("onAudit");
        this.triggerMethod('aggregate:audit');
    },

    onSend: function () {
        console.log("onSend");
        this.triggerMethod('aggregate:send');
    },

    onMarkAsSent: function () {
        console.log("onMarkAsSent");
        this.triggerMethod('aggregate:mark:as:sent');
    },

    onMarkAsDelivered: function () {
        console.log("onMarkAsDelivered");
        this.triggerMethod('aggregate:mark:as:delivered');
    },

    onOpenSelectedDocuments: function () {
        window.open("/#documents?" + (this.getSelectedDocuments() || []).map(function (id) {
            return "id=" + id;
        }).join("&"));
    },

    onExpandOrCollapse: function (event) {
        var expandOrCollapseElement = $(event.target);
        var expandAllText = "Expand All";
        var collapseAllText = "Collapse All";
        var expandClass = "fa-plus-square";
        var collapseClass = "fa-minus-square";

        if (expandOrCollapseElement.attr("title") == expandAllText) {
            expandOrCollapseElement.attr("title", collapseAllText);
            expandOrCollapseElement.removeClass(expandClass);
            expandOrCollapseElement.addClass(collapseClass);
            $('.expandable').collapse('show');
        } else {
            expandOrCollapseElement.attr("title", expandAllText);
            expandOrCollapseElement.removeClass(collapseClass);
            expandOrCollapseElement.addClass(expandClass);
            $('.expandable').collapse('hide');
        }
    },

    expandAll: function (target) {
        var collapseAllText = "Collapse All";
        var collapseClass = "fa-minus-square";
        var expandClass = "fa-plus-square";

        target.attr("title", collapseAllText);
        target.removeClass(expandClass);
        target.addClass(collapseClass);
        $('.expandable').collapse('show');
    },

    setAsInitialView: function () {
        var that = this;

        $.ajax({
            type: "POST",
            url: '/api/person/initial-url',
            contentType: 'text/plain',
            data: that.getUrlAsInitialView(),
            statusCode: {
                200: function () {
                    $.notify({
                        message: 'Initial View was set successfully'
                    }, {
                        type: 'success',
                        z_index: 2000
                    });
                }
            },
            error: function (e) {
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    getUrlAsInitialView: function () {
        var that = this;
        var params = _.extend(that.utils.deepClone(that.extraParams), that.aggregateParams);
        that.utils.mergeObjectsLeft(params, {"initial-view": "sorting-report"});
        var url = window.location.hash.split('?')[0] + '?' + that.utils.objectToQueryParams(params);
        return url;
    },

    extraParamsToString: function () {
        var extraParamsForLinks = {};
        _.each(this.extraParams, function (val, key) {
            if (key != 'ORGANIZATION_REVIEW_FINISHED_REQUEST' && key != 'ORGANIZATION_REVIEW_REQUEST' && key != 'ORGANIZATION_REVIEW_DELETED'
                && key != 'PERSON_REVIEW_FINISHED_REQUEST' && key != 'PERSON_REVIEW_REQUEST' && key != 'PERSON_REVIEW_DELETED' && key != 'object_status') {
                extraParamsForLinks[key] = val;
            }
        });

        return this.utils.objectToQueryParams(extraParamsForLinks);
    }

});


module.exports = DocumentsStatisticsAggregateView;


//////////////////
// WEBPACK FOOTER
// ./app/views/statistics/documents-statistics-aggregate-view.js
// module id = 305
// module chunks = 0